import React, { useEffect, useRef, useState } from "react";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { Dropdown } from "bootstrap";
import { Link } from "react-router-dom";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import PersonAddAlt1SharpIcon from "@mui/icons-material/PersonAddAlt1Sharp";
import PersonRemoveAlt1SharpIcon from "@mui/icons-material/PersonRemoveAlt1Sharp";
import PersonAddAltSharpIcon from "@mui/icons-material/PersonAddAltSharp";
import { set } from "lodash";
import { useTranslation } from "react-i18next";

const RecommendationAction = ({
  showDropdown,
  setShowDropdown,
  item,
  setPR,
  GetRecommendation,
  setRecommendationList,
  index,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const { t } = useTranslation();
  // console.log("GetRecommendation", GetRecommendation);
      const language = localStorage.getItem("Lang");


  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const handleToggleDropdown = (index) => {
    setShowDropdown((prev) => (prev === index ? null : index));
  };
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(null);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [followedId, setFollowedId] = useState("");
  const [isFollowed, setIsFollowed] = useState(false);
  const [showfollowModal, setShowFollowModal] = useState(false);

  const handleUnfollowCloseModal = () => {
    setShowFollowModal(false);
    // setSelectedItem(null);
  };

  const handleConfirmAction = () => {
    unFollowUser();
    handleUnfollowCloseModal();
  };

  //   const FollowedUser = async (id) => {
  //     // console.log("userUid", id, item.userUid);
  //   // setIsFollowed(false);
  //   setFollowedId(id);
  //     const data = {
  //       deviceType: "Web",
  //       sessionId: sessionId,
  //       userUID: id,
  //     };
  //     try {
  //       await axios.post("UserFollow/FollowUser", data).then((resData) => {
  //         setToastMessage(resData.data.message);
  //         setShowToast(true);
  //          setPR((prevList) =>
  //           prevList.map((item) =>
  //             item.userUid === userUID
  //               ? { ...item, isFollowedByYou: true }
  //               : item
  //           )
  //         );
  //         // setIsFollowed(true); 
  //         setFollowedId(item?.userUid);
  //       });
  //     } catch (error) {

  //       if (error.response && error.response.status === 404) {
  //         setWarningToastMessage(error.response.data.message);
  //         setShowWarningToast(true);
  //       } else {
  //         setErrorToastMessage(error.response.data.message);
  //         setShowErrorToast(true);
  //       }
  //     }
  //   };

  //  const unFollowUser = async (id) => {
  //   //  setIsFollowed(false);
  //     const responseData = {
  //       deviceType: "Web",
  //       sessionId: sessionId,
  //       userUID: followedId,
  //     };
  //     console.log("unfllow new res", responseData);
  //     try {
  //       await axios.post(`UserFollow/UnfollowUser`, responseData).then((res) => {
  //         console.log("res", res);
  //         setToastMessage(res.data.message);
  //         setShowToast(true);
  //          setPR((prevList) =>
  //           prevList.map((item) =>
  //             item.userUid === userUID
  //               ? { ...item, isFollowedByYou: false }
  //               : item
  //           )
  //         );
  //         // setIsFollowed(true); 
  //         setFollowedId(item?.userUid);
  //       });
  //     } catch (e) {
  //       console.log('cxc', e);
  //         //  setIsFollowed(false);
  //         setFollowedId(null);
  //       if (e.response && e.response.status === 404) {
  //         setWarningToastMessage(e.response.data.message);
  //         setShowWarningToast(true);
  //       } else {
  //         setErrorToastMessage(e.response.data.message);
  //         setShowErrorToast(true);
  //       }
  //     }
  //   };


  // FOLLOW USER

  const FollowedUser = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: id,
      langKey: language === "en" ? "" : language,
    };

    try {
      const resData = await axios.post("UserFollow/FollowUser", data);
      console.log("Follow===>", resData);

      setToastMessage(resData.data.message);
      setShowToast(true);

      // update list state immediately
      setPR((prevList) =>
        prevList.map((item) =>
          item.userUid === id
            ? { ...item, isFollowedByYou: true }
            : item
        )
      );
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else if (error.response) {
        setErrorToastMessage(error.response.data?.message);
        setShowErrorToast(true);
      } else {
        setErrorToastMessage(error.response?.data?.message);
        setShowErrorToast(true);
      }
    }
  };

  // UNFOLLOW USER
  const unFollowUser = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: followedId,
      langKey: language === "en" ? "" : language,
    };

    try {
      const resData = await axios.post("UserFollow/UnfollowUser", data);
      console.log("Unfollow===>", resData);

      setToastMessage(resData.data.message);
      setShowToast(true);

      // update list state immediately
      setPR((prevList) =>
        prevList.map((item) =>
          item.userUid === followedId
            ? { ...item, isFollowedByYou: false }
            : item
        )
      );
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else if (error.response) {
        setErrorToastMessage(error.response.data?.message);
        setShowErrorToast(true);
      } else {
        setErrorToastMessage(error.response?.data?.message);
        setShowErrorToast(true);
      }
    }
  };


  //************************ Connect User Start  ************************//
  const [connectId, setConnectId] = useState("");

  const ConnectUser = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: id,
      langKey: language === "en" ? "" : language,
    };

    try {
      const resData = await axios.post("Connection/SendConnectionRequest", data);
      console.log("isConnect===>", resData);
      setToastMessage(resData.data.message);
      setShowToast(true);

      setPR((prevList) =>
        prevList.map((item) =>
          item.userUid === id
            ? { ...item, isConnectedByYou: true }
            : item
        )
      );
      //  GetRecommendation();

    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message || "Something went wrong");
        setShowWarningToast(true);
      } else if (error.response) {
        setErrorToastMessage(error.response.data?.message || "Something went wrong");
        setShowErrorToast(true);
      } else {
        setErrorToastMessage(error.response.data.message || "Network error, please try again");
        setShowErrorToast(true);
      }
    }
  };


  //************************ Connect User  End  ************************//
  //************************Cancel Request   ************************//
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = (item) => {
    // setSelectedItem(item);
    // setSelectedUserId(item.userUid);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    // setSelectedItem(null);
  };
  const [show, setShow] = useState(false);
  const cancelRequestOpen = () => {
    setShow(true);
  };
  const cancelRequestClose = () => {
    setShow(false);
  };
  // const [skillId, setSkillId] = useState("");
  const [userUID, setuserUID] = useState("");

  const CancelRequest = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: userUID,
      langKey: language === "en" ? "" : language,
    };

    try {
      const resData = await axios.post("Connection/CancelConnectionRequest", data);
      console.log("Cancel Connect===>", resData);
      setShow(false);
      setToastMessage(resData.data.message);
      setShowToast(true);

      setPR((prevList) =>
        prevList.map((item) =>
          item.userUid === userUID
            ? { ...item, isConnectedByYou: false }
            : item
        )
      );
      // GetRecommendation();

    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message || "Something went wrong");
        setShowWarningToast(true);
      } else if (e.response) {
        setErrorToastMessage(e.response.data?.message || "Something went wrong");
        setShowErrorToast(true);
      }
      else {
        setErrorToastMessage(e.response.data.message || "Network Error");
        setShowErrorToast(true);
      }
    }
  };

  return (
    <>
      {item?.isFollowedByYou === true
      //  || isFollowed === true
      // (followedId === item?.userUid || isFollowed === true) 
      ? (
        <button
          type="submit"
          className="wljDangerBtn wlj-chip-btn me-3"
          onClick={() => {
             setShowFollowModal(true);
             setFollowedId(item.userUid)
          }}
        >
          <PersonRemoveAlt1SharpIcon />
          {t("Connections.Unfollow")}
         
        </button> 
      ) : (
        <button
          type="submit"
          className="wljPrimaryBtn wlj-chip-btn me-3"
          onClick={() => {
            FollowedUser(item.userUid);
            setFollowedId(item.userUid)
          }}
        >
          <PersonAddAlt1SharpIcon />
          {t("Connections.Follow")}
        </button>
      )}

      {item?.isConnectedByYou === true ? (
        <button
          type="submit"
          className="wljDangerBtn wlj-chip-btn"
          onClick={() => {
            cancelRequestOpen();
            setuserUID(item.userUid);
          }}
        >
          <CloseSharpIcon />
          {t("Connections.Cancel")}
            
        </button>
      ) : (
        <button
          type="submit"
          className="wljPrimaryBtn wlj-chip-btn"
          onClick={() => {
            ConnectUser(item.userUid);
            setConnectId(item.userUid);
          }}
        >
          <PersonAddAltSharpIcon />
          {t("Connections.Connect")}
        </button>
      )}



      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
      {show && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are You Sure You want to Cancel Request?")}</h6>

                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    cancelRequestClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => CancelRequest()}
                >
                  {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>
                 {t("modals.Are you sure you want to Disconnect")}
                  {/* <b>{selectedItem?.fullName}</b> ? */}
                </h6>

                {/* <span
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => {
                                        handleCloseModal();
                                    }}
                                >
                                    close
                                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseModal();
                  }}
                />
              </div>

              <div className="text-end mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => CancelRequest()}
                >
                  {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showfollowModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>
                  {t("modals.Are you sure you want to unfollow")}
                </h6>

                {/* <span
                       
                      >
                        close
                      </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleUnfollowCloseModal();
                  }} />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => handleConfirmAction()}
                >
                  {t("Recommendations.Unfollow")}                      </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default RecommendationAction;
